export interface WeaponsSeo {
  title: string
  seoTitle: string
  description: string
  subtitle: string
  keywords?: string
  image?: string
}

export function useWeaponsSeo({
  category,
  weapon,
  weaponFullName,
}: {
  category?: string
  weapon?: string
  weaponFullName?: string
}): WeaponsSeo | null {
  if (!category) {
    return null;
  }

  const isAll = !weapon;
  const categoryLowerCase = getModifiedString(category).replaceAll('-', '_');
  const weaponLowerCase = getModifiedString(weapon).replaceAll('-', '_');
  const { t } = useI18n();

  const seoObject: WeaponsSeo = {
    title: '',
    seoTitle: '',
    subtitle: '',
    description: '',
    keywords: '',
    image: '',
  };
  const weaponTranslate = t(`filters.weapon.${isAll ? category : weapon}`);

  if (isAll) {
    seoObject.seoTitle = t(
      'weapons_seo.all_weapons_page.seo_title',
      {
        category: categoryLowerCase === 'heavy'
          ? t('heavy_weapons')
          : weaponTranslate,
      },
    );
    seoObject.title = t(
      'weapons_seo.all_weapons_page.title',
      {
        category: categoryLowerCase === 'heavy'
          ? t('heavy_weapons')
          : weaponTranslate,
      },
    );
    seoObject.subtitle = t(`weapons_seo.all_weapons_page.subtitles.${categoryLowerCase}`);
    seoObject.description = t(`weapons_seo.all_weapons_page.descriptions.${categoryLowerCase}`);
    return seoObject;
  }

  if (categoryLowerCase === 'other') {
    seoObject.seoTitle = t(
      'weapons_seo.other.seo_title',
      {
        weapon: weaponTranslate,
      },
    );
    seoObject.title = t(
      'weapons_seo.other.title',
      {
        weapon: weaponTranslate,
      },
    );
    seoObject.subtitle = t(`weapons_seo.other.subtitles.${weaponLowerCase}`);
    seoObject.description = t(`weapons_seo.other.descriptions.${weaponLowerCase}`);

    return seoObject;
  }

  if (categoryLowerCase === 'gloves') {
    seoObject.seoTitle = t(
      'weapons_seo.gloves.seo_title',
      {
        weapon: weaponTranslate,
      },
    );
    seoObject.title = t(
      'weapons_seo.gloves.title',
      {
        weapon: weaponTranslate,
      },
    );
    seoObject.subtitle = t(
      'weapons_seo.gloves.subtitle',
      {
        weapon: weaponTranslate,
      },
    );
    seoObject.description = t(
      'weapons_seo.gloves.desc',
      {
        weapon: weaponTranslate,
      },
    );
    seoObject.keywords = t(
      'weapons_seo.gloves.keywords',
      {
        weapon: weaponTranslate,
      },
    );

    return seoObject;
  }

  seoObject.seoTitle = t(
    'weapons_seo.for_all_weapons.seo_title',
    {
      weapon: weaponTranslate,
    },
  );
  seoObject.description = t(
    'weapons_seo.for_all_weapons.description',
    {
      weapon: weaponTranslate,
    },
  );
  seoObject.title = weaponFullName?.toLowerCase()?.includes('collect')
    ? `${t('inspect_all_skins', { name: weaponTranslate })}`
    : `${t('all_skins', { name: weaponTranslate })}`;
  seoObject.subtitle = t(`weapon_page_title`, { name: weaponTranslate });

  return seoObject;
}
